import Article from 'images/search-icons/article.png';
import Faq from 'images/search-icons/faq.png';
import CsLogo from 'images/logos/square-logo.gif';

function parseLink(linkTemplate, rawHit) {
  if (linkTemplate) {
    return linkTemplate.replace(':objectID', rawHit.objectID);
  }
  if (rawHit.page_type === 'zendesk_article') {
    return rawHit.custom_url;
  }
  return `/${rawHit.custom_url}`;
}

function parseImage(rawHit) {
  if (rawHit.image) {
    return rawHit.image;
  }

  switch (rawHit.page_type) {
    case "alchemy_page":
      return Article;
    case "zendesk_article":
      return Faq;
    default:
      return CsLogo;
  }
}

function parsePageText(rawText) {
  if (Array.isArray(rawText)) {
    return rawText.join(' ')
  }
  return rawText
}

function parseRawSearchResult({ rawHit, adminLinkTemplate = null, includePageText = false }) {
  const parsed = {
    id: rawHit.objectID,
    name: rawHit.name,
    highlightedName: rawHit._highlightResult.name.value,
    permalink: parseLink(adminLinkTemplate, rawHit),
    pageType: rawHit.page_type,
    imagePath: parseImage(rawHit),
    minPrice: rawHit.min_price,
    maxPrice: rawHit.max_price,
    rating: rawHit.rating,
  };
  if (includePageText) {
    parsed.pageText = parsePageText(rawHit.page_text);
  }
  return parsed;
}

export default parseRawSearchResult;
